import React from "react";
import { RouteObject } from "react-router-dom";

import { WIDGET_ROUTES } from "../../routes";

export const WidgetLibraryRoutes: RouteObject[] = [
  {
    path: WIDGET_ROUTES.WidgetLibrary_Experiences,
    lazy: async () => {
      const { WidgetLibraryRoute } = await import(
        "../../../domains/WidgetLibrary/WidgetLibrary.route"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            isEnabled={(org) => true}
            debugId={WIDGET_ROUTES.WidgetLibrary_Experiences}
            children={WidgetLibraryRoute}
          />
        ),
      };
    },
  },
  {
    path: WIDGET_ROUTES.WidgetLibrary_Sitewide,
    lazy: async () => {
      const { WidgetLibraryRoute } = await import(
        "../../../domains/WidgetLibrary/WidgetLibrary.route"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            isEnabled={(org) => true}
            debugId={WIDGET_ROUTES.WidgetLibrary_Sitewide}
            children={WidgetLibraryRoute}
          />
        ),
      };
    },
  },
];
